import {
    SET_ATTACHMENT,
    RESET_ATTACHMENTS,
    UPDATE_ATTACHMENT,
    UNSET_ATTACHMENTS
} from '../actions/types.js';

const initialState = {
    lastAdded: {
        id: null,
        user_id: '',
        file_name: null,
        url: '',
        type: '',
        created_at: '',
        updated_at: ''
    },
    all: []
}

export function attachment(state = initialState, action = {}) {
    switch (action.type) {
        case SET_ATTACHMENT:
            const newAttachments = state.all.concat(action.attachment);
            return Object.assign({}, state, {all: newAttachments});
        case UPDATE_ATTACHMENT:
            const newState = state.all.map(a => {
                if (a.id === action.attachment.id) {
                    return Object.assign({}, a, action.attachment)
                } else {
                    return a;
                }
            });

            return Object.assign({}, state, {all: newState});
        case UNSET_ATTACHMENTS:
            const filtered = state.all.filter(a => !action.attachments.includes(a.id));
            return Object.assign({}, state, {all: filtered});
        case RESET_ATTACHMENTS:
            return initialState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/attachment.js